import { render, staticRenderFns } from "./indexShopKf.vue?vue&type=template&id=60746a66&scoped=true"
import script from "./indexShopKf.vue?vue&type=script&lang=js"
export * from "./indexShopKf.vue?vue&type=script&lang=js"
import style0 from "./indexShopKf.vue?vue&type=style&index=0&id=60746a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60746a66",
  null
  
)

export default component.exports